const mapLinkVariant = {
  sm: "12_18_600",
  md: "14_18_600",
  lg: "16_24_600",
  xl: "18_30_600"
}, LINK_DISABLED_CLASSNAME = "link-disabled";
export {
  LINK_DISABLED_CLASSNAME,
  mapLinkVariant
};
//# sourceMappingURL=constants.js.map
